import { SearchInput } from '../atoms/SearchInput';

interface TreeSearchBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  matchCount: number;
}

/**
 * Molecule component for tree search bar with match counter
 */
export function TreeSearchBar({ 
  searchQuery, 
  onSearchChange, 
  matchCount 
}: TreeSearchBarProps) {
  return (
    <div className="p-2 border-b border-gray-200 bg-gray-50">
      <SearchInput
        value={searchQuery}
        onChange={onSearchChange}
        placeholder="Search by name or ID..."
      />
      {searchQuery && (
        <div className="mt-1 text-xs text-gray-600">
          {matchCount} {matchCount === 1 ? 'match' : 'matches'} found
        </div>
      )}
    </div>
  );
}
